function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { zodResolver } from '@hookform/resolvers/zod';
import equals from 'fast-deep-equal';
import merge from 'lodash/merge';
import { Controller, FormProvider, useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';
// TODO i18n
var customErrorMap = function(issue) {
    if (issue.code === z.ZodIssueCode.invalid_type) {
        if (issue.expected && issue.input === undefined) {
            return {
                message: 'Must be present'
            };
        }
    }
    return undefined;
};
z.setErrorMap(customErrorMap);
export function useZodForm(schema, props) {
    var resolver = zodResolver(schema);
    var form = useForm(_object_spread({
        resolver: /*#__PURE__*/ _async_to_generator(function() {
            var _len, args, _key, context, _ref, errors, values, mergedErrors;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _arguments[_key];
                        }
                        context = args[1];
                        // First trigger built-in validation handling that normally is disabled when resolver is used
                        // This function relies on the react-hook-form patch
                        return [
                            4,
                            context.executeBuiltInValidation()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            resolver.apply(void 0, _to_consumable_array(args))
                        ];
                    case 2:
                        _ref = _state.sent(), errors = _ref.errors, values = _ref.values;
                        // Combine errors to report all errors at once. otherwise executeBuiltInValidation won't show
                        // until the next change event
                        mergedErrors = merge({}, form.formState.errors, errors); // eslint-disable-line
                        if (Object.keys(mergedErrors).length) return [
                            2,
                            {
                                errors: mergedErrors,
                                values: {}
                            }
                        ];
                        return [
                            2,
                            {
                                errors: {},
                                values: values
                            }
                        ];
                }
            });
        })
    }, props));
    // access this property so we always "subscribe" to dirty changes in case of call to reset
    // https://github.com/react-hook-form/react-hook-form/issues/8341
    form.formState.dirtyFields;
    // This field is used by inputs to create a mapping of form value -> labels globally available
    // in the form context. This is useful for rendering errors apart from their individual fields
    if (!form.labels) {
        form.labels = {};
    }
    // by default, react-hook-form only cares about the defaultValues passed in at mount. A more
    // ergonomic hook is one that updates the forms defaults when the specified default values change.
    if ((props === null || props === void 0 ? void 0 : props.defaultValues) && typeof props.defaultValues !== 'function' && !equals(props === null || props === void 0 ? void 0 : props.defaultValues, form.formState.defaultValues)) {
        form.reset(props === null || props === void 0 ? void 0 : props.defaultValues, {
            keepDirtyValues: true
        });
    }
    return form;
}
export function useZodFormContext(schema) {
    return useFormContext();
}
export { Controller, FormProvider };
